import { analyticsService, AnalyticsEventCatalog } from "../index";

/**
 * @param {'referee'|'spectator'|string} role
 * @param {{ registerAsCreator?: boolean; isDeputy?: boolean }} [ctx]
 * @returns {'owner'|'referee'|'deputy'|'player'|'spectator'}
 */
export function mapAnalyticsJoinRole(role, ctx = {}) {
  if (ctx.registerAsCreator) return "owner";
  if (ctx.isDeputy && role === "referee") return "deputy";
  if (role === "referee") return "referee";
  if (role === "spectator") return "spectator";
  return "player";
}

/**
 * @param {{ creatorPlays?: boolean; isPrivate?: boolean; roomLabelPresent?: boolean }} params
 */
export function trackRoomCreated(params) {
  analyticsService.track(AnalyticsEventCatalog.ROOM_CREATED, {
    creator_plays: params.creatorPlays !== false,
    is_private: Boolean(params.isPrivate),
    room_label_present: Boolean(params.roomLabelPresent),
  });
}

/**
 * @param {{
 *   joinRole: 'owner'|'referee'|'deputy'|'player'|'spectator';
 *   joinSource?: 'code'|'link'|'qr'|'resume';
 * }} params
 */
export function trackRoomJoined(params) {
  analyticsService.track(AnalyticsEventCatalog.ROOM_JOINED, {
    join_role: params.joinRole,
    join_source: params.joinSource || "code",
  });
}

/**
 * @param {{
 *   archiveReason: 'completed'|'abandoned'|'creator_archived';
 *   matchesCompletedCount?: number;
 * }} params
 */
export function trackRoomArchived(params) {
  /** @type {import('../analytics.types').AnalyticsEventParams} */
  const payload = {
    archive_reason: params.archiveReason,
  };
  if (
    typeof params.matchesCompletedCount === "number" &&
    params.matchesCompletedCount >= 0
  ) {
    payload.matches_completed_count = params.matchesCompletedCount;
  }
  analyticsService.track(AnalyticsEventCatalog.ROOM_ARCHIVED, payload);
}
